import { render, staticRenderFns } from "./StaffTeam.vue?vue&type=template&id=2c5122d6&scoped=true"
import script from "./StaffTeam.vue?vue&type=script&lang=js"
export * from "./StaffTeam.vue?vue&type=script&lang=js"
import style0 from "./StaffTeam.vue?vue&type=style&index=0&id=2c5122d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5122d6",
  null
  
)

export default component.exports